import { useIntl } from 'react-intl';

import { useListingState } from '@/hooks/useListingState';
import { commonMessages } from '@/messages/common';
import { listingActions } from '@/states/listingState';

import { useListingFiltersProvider } from '../../ListingFiltersProviderContext';

import { ReactComponent as FilterSvg } from '@/assets/icons/filter.svg';

import * as S from './FiltersButton.styles';

// BEC-24437: attribute of the Diameter (Size) filter group, pre-expanded by
// default when the Watch PLP filter panel opens.
const DEFAULT_OPEN_TAB_BY_LISTING: Partial<Record<string, string>> = {
  WATCH: 'size',
};

export const FiltersButton = ({ isWidget = false }: { isWidget?: boolean }) => {
  const { formatMessage } = useIntl();
  const { listingType } = useListingState();
  const { listingFiltersType } = useListingFiltersProvider();

  const handleClick = () => {
    if (isWidget) {
      window.parentIFrame?.autoResize(false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.parentIFrame?.resize(1024 as any);
    }

    // Pre-expand the default group (Diameter on Watch PLP) each time the panel
    // opens; other listing types / search view keep all groups collapsed.
    const defaultOpenedTab =
      listingFiltersType === 'PLP'
        ? DEFAULT_OPEN_TAB_BY_LISTING[listingType]
        : undefined;

    listingActions.updateModalState({
      status: 'OPEN',
      openedTab: defaultOpenedTab ?? null,
    });
  };

  return (
    <S.FiltersButton data-testid='FiltersButton' onClick={handleClick}>
      {formatMessage(commonMessages.filters)}
      <FilterSvg />
    </S.FiltersButton>
  );
};

FiltersButton.displayName = 'FiltersButton';
